import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import PdpSharedContactDealerButton from '../PdpSharedButtons/PdpSharedContactDealerButton';
import PdpSharedRequestHold from '../PdpSharedButtons/PdpSharedRequestHold';

// styles
import styles from './PdpRespSidebarContact.scss';

// helpers
import get from 'lodash.get';

export const PdpRespSidebarContact = props => {
    const { item, user, itemId, userId } = props;
    const pricingDisplayInfo = get(props, 'displayInfo.pricing') || null;
    const vipSalesRep = get(props, 'vipUserRelationship.userDataB[0]') || null;
    const isVipUser = !!user && !user.isVerifiedTrade && !!vipSalesRep;

    if (
        !item ||
        !pricingDisplayInfo ||
        (isVipUser && !(pricingDisplayInfo.showSold || pricingDisplayInfo.showUnavailable))
    ) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.questions}>
                <FormattedMessage
                    id="PdpRespSidebarContact.questionsAboutPiece"
                    defaultMessage="Questions about this piece?"
                />
            </div>
            <div className={styles.buttons}>
                <div className={styles.requestPrice}>
                    <PdpSharedContactDealerButton size="small" user={user} item={item} />
                </div>

                <PdpSharedRequestHold
                    item={item}
                    userId={userId}
                    itemId={itemId}
                    trackingLocation="pdp sidebar"
                />
            </div>
        </div>
    );
};

PdpRespSidebarContact.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    item: PropTypes.object,
    isClient: PropTypes.bool,
    relay: PropTypes.object,
    small: PropTypes.bool,
    user: PropTypes.object,
};

export default createFragmentContainer(PdpRespSidebarContact, {
    displayInfo: graphql`
        fragment PdpRespSidebarContact_displayInfo on ItemDisplayInfo {
            pricing {
                showSold
                showUnavailable
            }
        }
    `,
    item: graphql`
        fragment PdpRespSidebarContact_item on Item {
            isCustomizable
            ...PdpSharedRequestHold_item
            ...PdpSharedContactDealerButton_item
            ...PdpSharedMakeOfferButton_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarContact_user on User {
            isVerifiedTrade
            ...PdpSharedContactDealerButton_user
            ...PdpSharedMakeOfferButton_user
        }
    `,
    vipUserRelationship: graphql`
        fragment PdpRespSidebarContact_vipUserRelationship on UserRelationship {
            userDataB {
                ... on VipRepData {
                    email
                    firstName
                    phoneNumber(formatType: INTERNATIONAL)
                }
            }
        }
    `,
});
